import React from "react"
import { useParams } from "react-router-dom"
import { Edit } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import BarChartIcon from "@mui/icons-material/BarChart"
import ScheduleIcon from "@mui/icons-material/Schedule"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import { ScheduleForm } from "components/schedule"

function ScheduleEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { devid } = useParams<{ devid: string }>()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", id: devid, icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", id: devid, icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", id: devid, icon: <BarChartIcon/> },
    ]

    return (
        <Edit title={translate('resources.schedules.edit')}
            resource={`schedules`} 
            mutationMode="pessimistic"
            redirect={`/devices/${devid}/schedules`}
            actions={<RecordActionsTabs subTabs={subTabs} resourceParent="devices" resourceParentId={devid} />} 
        >
            <ScheduleForm />
        </Edit>
    )
}

export default ScheduleEdit